import $ from 'jquery';
import moment from 'moment';
import {MapsResultView} from '../components/maps-result-view.ts';
import {ListResultView} from '../components/list-result-view.ts';
import Cookies from 'js-cookie'
import {__} from "../libraries/translations.ts";

export class ActivityController {

    form;

    defaultValues = {};

    url = '';

    scheduledSearch = null;

    mapsResultViewer = null;
    listResultViewer = null;

    afterFavoriteClicked = null;
    afterRenderEvent = null;
    cookieKey = '';
    selection = [];
    selectionMode = false;

    constructor(container, form, paginationOptionContainer, paginationContainer, defaultValues = {}, mapsView = null, cookieKey = 'events') {
        this.cookieKey = cookieKey;
        this.form = form;
        this.defaultValues = defaultValues

        $(this.form).submit(event => {
            event.preventDefault();
            this.find();
        });

        this.bindEvents();
        this.bindReset();

        this.listResultViewer = new ListResultView(container, paginationOptionContainer, paginationContainer);
        this.listResultViewer.onFavoriteClicked((event) => this.favoriteClicked(event));
        this.listResultViewer.onTriggerFind((event) => this.find());

        if (mapsView !== null) {
            this.mapsResultViewer = new MapsResultView(mapsView);
        }

        this.getActiveResultView().putActivities({data: [], fresh: true}, this.getLayoutName());
    }

    onFavoriteClicked(event) {
        this.afterFavoriteClicked = event;
    }

    afterRender(event) {
        this.afterRenderEvent = event;
    }

    bindEvents() {
        this.form.find('input[type=text],input[type=number]').keyup(_ => {
            if (!this.onMobile()) {
                this.setTimeout();
            }
        });
        this.form.find('input[name=location],select,input[type=radio],input[type=checkbox],input[name=distance]').change(_ => {
            if (!this.onMobile()) {
                this.find();
            }
        });
        this.form.find('input.date-find').on('apply.daterangepicker', _ => {
            if (!this.onMobile()) {
                this.setTimeout(10);
            }
        });
        $('#mobileFilterSubmit').click(_ => {
            this.find();
        });
    }

    bindReset() {
        this.form.find('button.reset-form').click(_ => {
            this.form.find('input[type=text],input[type=number]').val('');
            this.form.find('input[name=location],select').val('');
            this.form.find('input[type=checkbox]').prop('checked', false);
            this.form.find('[name=perPage]:first').val(18);
            this.form.find('input[name=distance]').val(50000);
        });
    }

    find() {
        this.clearTimeout();
        this.hideInactiveResultView();

        $.ajax({
            url: this.form.attr('action'),
            method: 'POST',
            data: this.getFormInputs(),
            success: (response) => {
                response.data = this.preProcessData(response.data);
                this.getActiveResultView().putActivities(response, this.getLayoutName());
                if (!!this.afterRenderEvent) {
                    this.afterRenderEvent();
                }
            }
        });
    }

    enableSelection(onChange) {
        this.listResultViewer.onClick((event) => {
            event.preventDefault();
            event.stopPropagation();

            const target = $(event.target).closest('.mos-selectable');
            const userId = target.data('user-id');
            const wasSelected = $(target).hasClass('selected');
            $(target).toggleClass('selected');

            if(wasSelected) {
                this.selection.splice(this.selection.indexOf(userId),1);
            } else {
                this.selection.push(userId);
            }

            onChange(this.selection);
        });
        this.selectionMode = true;
    }

    getFormInputs() {
        const values = {...this.defaultValues};
        const form = this.getInputsContainer();
        form.find(':input').each(function () {
            const val = $(this).val();
            if (val !== null && val !== undefined && val !== '') {
                values[this.name] = val;
            }
        });
        form.find('input[type=checkbox]').each(function () {
            values[this.name] = $(this).is(':checked') ? 1 : 0
        });
        values['_token'] = $('meta[name="csrf-token"]').attr('content');
        values['perPage'] = this.form.find('[name=perPage]:first').val();
        values['distance'] = form.find('input[name=distance]').val();

        const attributes = this.getActiveResultView().getSearchAttributes();
        for (let index in attributes) {
            values[index] = attributes[index];
        }

        return values;
    }

    preProcessData(data) {
        if(this.selectionMode) {
            for(const item of data) {
                item.selected = this.selection.indexOf(item.userId) > -1;
            }
        }

        for (const item of data) {
            if (!item.hasOwnProperty('startDateTime') || !item.hasOwnProperty('endDateTime')) {
                return data;
            }
            item.startDateTimeObj = moment(item.startDateTime, 'YYYY-MM-DD hh:ii')
            item.endDateTimeObj = moment(item.endDateTime, 'YYYY-MM-DD hh:ii')
            item.day = item.startDateTimeObj.calendar(__('moment.calendar'));
        }
        return data;
    }

    getLayoutName() {
        return this.form.find('input[name=layout]:checked').val() || 'events-default';
    }

    setTimeout(timeout = 300) {
        this.clearTimeout();
        this.scheduledSearch = setTimeout(_ => {
            this.find();
        }, timeout);
    }

    clearTimeout() {
        if (this.scheduledSearch !== null) {
            clearTimeout(this.scheduledSearch);
        }
    }

    favoriteClicked(event) {
        event.preventDefault();
        event.stopPropagation();

        const target = $(event.target);
        const wasFavorite = target.hasClass('isFavorite');
        const url = target.closest('.activity-item').data('activityUrl');
        target.toggleClass(['text-light-gray', 'text-danger', 'fa', 'fas', 'isFavorite']);

        $.ajax({
            method: 'patch',
            url: url,
            data: {
                action: wasFavorite ? 'unfavorite' : 'favorite',
                _token: $('meta[name=csrf-token]').attr('content')
            }
        });

        if (!!this.afterFavoriteClicked) {
            this.afterFavoriteClicked();
        }
    }

    getActiveResultView() {
        this.setLayoutCookie();
        const layoutType = this.getLayoutName();
        if (layoutType === 'events-map' && this.mapsResultViewer !== null) {
            return this.mapsResultViewer;
        }

        return this.listResultViewer;
    }

    hideInactiveResultView() {
        const layoutType = this.getLayoutName();
        if (layoutType === 'events-map' && this.mapsResultViewer !== null) {
            this.mapsResultViewer.show();
            this.listResultViewer.hide();
        } else {
            if (this.mapsResultViewer !== null) {
                this.mapsResultViewer.hide();
            }
            this.listResultViewer.show();
        }
    }

    setLayoutCookie() {
        const layout = this.form.find('input[name=layout]:checked').val();
        if (layout) {
            Cookies.set('layout-' + this.cookieKey, layout);
        }
    }

    onMobile() {
        const el = $('#mobileFilterSubmit');
        if (el.length === 0) {
            return false;
        }
        return el.closest('.offcanvas').css('visibility') !== 'hidden';
    }

    getInputsContainer() {
        if(this.onMobile()) {
            return this.form.find('.offcanvas');
        }

        const mainContainer = this.form.find('.search-inputs');
        if(mainContainer.length > 0) {
            return mainContainer;
        }

        return this.form;
    }
}
